<template>
    <div class="bgcolor" style="min-height: 100%;">
        <div class="paper_title_box">
            <div class="paper_title">{{testpaper_name}}</div>
        </div>
        <div class="container_warp">
            <div class="paper_left">
                <div class="see_box cursor" @click="toGrade">查看报告</div>
                <div class="card_box">
                    <div class="card_title_box">答题卡</div>
                    <div class="mark_wrap">
                        <div class="mark_box">
                            <div class="mark_item" v-for="(val,key) in cardMark" :key="key">
                                <div class="mark_dot" :class="{'mark_dot_white':key==2,'mark_dot_red':key==1}"></div>{{val}}
                            </div>
                        </div>
                    </div>
                    <div class="card_opt" v-if="topic_data.length">
                        <template v-for="(val,key) in topic_data">
                            <div class="card_opt_title" v-if="key==0">{{val.genre.genre_name}}</div>
                            <template v-else-if="val.genre.genre_name!=topic_data[key-1].genre.genre_name">
                                <div class="card_opt_title">{{val.genre.genre_name}}</div>
                            </template>
                            <div class="card-btn-box">
                                <div @click="cardNav(key)" class="cu-btn cursor" :class="{'w_active':val.item_status==='wrong','r_active':val.item_status==='right'}">{{key+1}}</div>
                            </div>
                        </template>
                        
                    </div>
                </div>
            </div>
            <!-- <div class="paper_left_flot"></div> -->
            <div class="paper_right">
                <div class="topic_main" :id="'h'+index" v-for="(subject,index) in topic_data" :key="index">
                    <div class="topic_title_box" :class="{'tpc_top':index!=0}" v-if="index==0||subject.genre.genre_name!==topic_data[index-1].genre.genre_name">{{subject.genre.genre_name}}</div>
                    <div class="topic_wrap_pl">
                        <div class="topic_item">
                            <div class="material_box tpc_top" v-if="subject.material&&(index==0||!topic_data[index-1].material||topic_data[index-1].material.topic_stem!=subject.material.topic_stem)" v-html="strcharacterDiscode(subject.material.topic_stem)" @click="previewPicture($event)"></div>
                        </div>
                        <div class="topic_num_box" :class="{'topic_num_topline':index!=0&&(!subject.material&&subject.genre.genre_name==topic_data[index-1].genre.genre_name)}">
                            <div class="tnb_left">
                                <div class="tn_dot"></div>{{index+1}}/{{topic_data.length}}
                            </div>
                            <div class="tnb_right cursor">
                                <div class="tnb_right_w" @click="openPopfk(subject)"><img class="fk_img" src="../assets/fk.png" alt=""> 错题反馈</div>
                                <div class="tnb_right_s" @click="FavorSubject(subject,index)"><img class="fk_img" :src="subject.userFavor?require('../assets/icon_collection2.png'):require('../assets/icon_collection1.png')" alt=""> 收藏</div>
                            </div>
                        </div>
                        <div class="txt_vh tpc_top" v-html="strcharacterDiscode(subject.title)" @click="previewPicture($event)"></div>
                        <div class="opt_group_box" v-if="subject.type==1||subject.type==2">
                            <div class="radio_opt_wrap" v-for="(option,idxs) in subject.optionList" :key="idxs">
                                <div class="radio_opt_box" :class="{'only_r':idxs===parseInt(subject.answer),'w_active':subject.item_status==='wrong'&&idxs===parseInt(subject.userAnswer),'r_active':subject.item_status==='right'&&idxs===parseInt(subject.userAnswer)}">{{option.text}}</div>
                                <div class="txt_vh" v-html="strcharacterDiscode(option.content)" @click="previewPicture($event)"></div>
                            </div>
                        </div>
                        <div class="opt_group_box" v-if="subject.type==3">
                           
                            <div class="radio_opt_wrap" v-for="(option,idxs) in subject.optionList" :key="idxs">
                                <template v-if="subject.item_status === null || subject.item_status === 'none'">
                                    <div class="radio_opt_box" :class="{'only_r':subject.answer[idxs]===idxs.toString()}">{{option.text}}</div>
                                </template>
                                <template v-else-if="subject.item_status === 'right'">
                                    <div class="radio_opt_box" :class="{'r_active':subject.userAnswer[idxs]===idxs.toString()}">{{option.text}}</div>
                                </template>
                                <template v-else-if="subject.item_status === 'wrong'">
                                    <div class="radio_opt_box only_r" v-if="subject.userAnswer[idxs]==undefined && subject.answer[idxs]!=undefined">{{option.text}}</div>
                                    <div class="radio_opt_box w_active" v-else-if="subject.userAnswer[idxs]!=undefined && subject.answer[idxs]==undefined">{{option.text}}</div>
                                    <div class="radio_opt_box r_active" v-else-if="subject.userAnswer[idxs]!=undefined && subject.answer[idxs]!=undefined">{{option.text}}</div>
                                    <div class="radio_opt_box" v-else>{{option.text}}</div>
                                </template>
                                <div class="txt_vh" v-html="strcharacterDiscode(option.content)" @click="previewPicture($event)"></div>
                            </div>
                            
                        </div>

                        <div class="opt_group_box" v-if="subject.type==4||subject.type==5">
                            <div class="self_score" :class="{'n_txt':subject.userAnswer=='','w_txt':subject.userAnswer!=''&&parseFloat(subject.userScore)<parseFloat(subject.score),'r_txt':subject.userAnswer!=''&&parseFloat(subject.userScore)==parseFloat(subject.score)}">我的自评：{{subject.userAnswer==''?'未进行自我评分':parseFloat(subject.userScore)+'分'}}</div>
                        </div>

                        <div class="anwer_box">
                            <div class="anwer_box_left">
                                <img class="statu_img" v-if="subject.type==1||subject.type==2||subject.type==3" :src="subject.item_status === null||subject.item_status === 'none'?require('../assets/statu2.png'):subject.item_status === 'right'?require('../assets/statu1.png'):require('../assets/statu3.png')" alt="">
                                <img class="statu_img" v-else :src="subject.userAnswer ==''?require('../assets/statu2.png'):require('../assets/statu1.png')" alt="">
                                <template v-if="subject.type==1||subject.type==2">
                                    <span :class="{'n_txt':subject.item_status === null||subject.item_status === 'none','r_txt':subject.item_status === 'right','w_txt':subject.item_status === 'wrong'}">我的作答：{{subject.item_status === null||subject.item_status === 'none'?'未作答':strOption[subject.userAnswer]}}</span>
                                </template>
                                <template v-else-if="subject.type==3">
                                    <span :class="{'n_txt':subject.item_status === null||subject.item_status === 'none','r_txt':subject.item_status === 'right','w_txt':subject.item_status === 'wrong'}">我的作答：</span>
                                    <span v-if="subject.item_status === null||subject.item_status === 'none'" class="n_txt">未作答</span>
                                    <span v-else :class="{'r_txt':subject.item_status === 'right','w_txt':subject.item_status === 'wrong'}" v-for="(s,k) in subject.userAnswer" :key="k">{{strOption[s]}}</span>
                                </template>
                                <span v-else-if="subject.type==4||subject.type==5" :class="subject.userAnswer ==''?'n_txt':'r_txt'">{{subject.userAnswer ==''?'我的作答：未作答 ':'我的作答：'}}</span>
                            </div>
                            <template v-if="subject.type==1||subject.type==2">
                                <div class="anwer_box_right">正确答案：{{strOption[subject.answer]}}</div>
                            </template>
                            <template v-else-if="subject.type==3">
                                <div class="anwer_box_right"><span>正确答案：</span><span v-for="(v,i) in subject.answer" :key="i">{{strOption[v]}}</span></div>
                            </template>
                            
                        </div>
                        <div v-if="(subject.type==4||subject.type==5)&&subject.userAnswer!=''" class="self_anwer_txt">{{subject.userAnswer}}</div>
                        <div class="j_anwer_box" v-if="subject.type==4||subject.type==5">
                            <div>答案</div>
                            <div class="j_anwer_content j_anwer_content_pt" v-if="subject.answer==''">暂无答案</div>
                            <div class="j_anwer_content" v-else v-html="strcharacterDiscode(subject.answer)" @click="previewPicture($event)"></div>
                        </div>
                        <div class="j_anwer_box analy_btm_padd" :class="{'topic_num_btmline':subject.material&&topic_data.length!=index+1}">
                            <div>解析</div>
                            <div class="j_anwer_content j_anwer_content_pt" v-if="subject.explain==''">暂无解析</div>
                            <div class="j_anwer_content" v-html="strcharacterDiscode(subject.explain)" @click="previewPicture($event)"></div>
                        </div>
                    </div>
                    
                </div>
                <div class="footer_block"></div>
            </div>
        </div>
                
                    <!-- 纠错弹框 -->
                    <el-dialog title="错题反馈" class="popup" :visible.sync="dialogFormVisible" center>
                        <div class="wrong_pop_title">
                            <div class="tn_dot"></div><div>错误类型（可多选）</div>
                        </div>
                        <div class="worng_nav_wrap">
                            <div class="worng_nav cursor" v-for="(val,key) in wrongFk" :key="key">
                                <div class="worng_nav_sub" :class="{'popw_active':val.checked}" @click="FKselect(key)">{{val.name}}</div>
                            </div>
                        </div>
                        <div class="wrong_pop_title w_mt">
                            <div class="tn_dot"></div><div>错误详情</div>
                        </div>
                        <div class="textarea_wrap">
                            <textarea v-model="textarea" maxlength="100"></textarea>
                        </div>
                        <div class="wrong_pop_btn cursor" :class="{'ogrey':selectchick.length==0}" @click="worngSubmit">提交</div>
                    </el-dialog>
                <!-- 自动交卷 -->
                <div class="shade" v-if="popupSubimt">
                    <div class="pop_submit">
                        <div class="pop_submit_title">做题时间已到，系统自动交卷</div>
                        <div class="pop_submit_btn" @click="closeSubmit">确定</div>
                        <i class="el-icon-close pop_i_close" @click="closeSubmit"></i>
                    </div>
                </div>
                <!-- 手动交卷弹框 -->
                <div class="shade" v-if="isSubmit">
                    <div class="pop_submit">
                        <div class="pop_submit_title">你还有试题尚未完成，是否交卷？</div>
                        <div class="pop_btm_btn">
                            <div class="p_left_btn" @click="closeSbtPop">继续做题</div>
                            <div class="p_right_btn" @click="SbtPop">交卷</div>
                        </div>
                        <i class="el-icon-close pop_i_close" @click="closeSbtPop"></i>
                    </div>
                </div>

                <!-- 二维码弹框 -->
                <div class="shade" v-if="isCode">
                    <div class="pop_submit code_pop_box">
                        <div class="pop_code_title">请添加客服老师领取现金红包</div>
                        <img v-if="codeData" class="code_icon" :src="codeData.qrcode" alt="">
                        <i class="el-icon-close pop_code_close" @click="closeCodePop"></i>
                    </div>
                </div>

        <img v-if="isScroll" class="scllotop_img" src="../assets/scllotop.png" alt="" @click="scllotop">
        <picture-preview :visible.sync="picturePreview.visible" :closeOnClickModal="picturePreview.closeOnClickModal" :src="picturePreview.src" />
    </div>
</template>

<script>
    import store from '../store'
    import CountDown from 'dircountdown'
    import SingleChoice from '@/components/SingleChoice'
    import MultipleChoice from '@/components/MultipleChoice'
    import TrueFalse from '@/components/TrueFalse'
    import Subjective from '@/components/Subjective'
    import strcharacterDiscode from '@/js/strcharacterDiscode'
    import PicturePreview from '@/components/PicturePreview/PicturePreview.vue'
    
    var flag=false;

    export default {
        name: 'DoTopic',
        components: {
            SingleChoice,
            MultipleChoice,
            TrueFalse,
            Subjective,
            CountDown,
            PicturePreview
        },
        data () {
            return {
                testpaper_name: '',
                topic_data: [],
                all_data: null,
                material_data: [],
                submitData: {},
                testTitle: '',
                // startSecond: '7200',
                startSecond: '',
                textarea: '',
                dialogFormVisible: false,
                formLabelWidth: '120px',
                tiGanTops: [],
                cardMark: ['答对','答错','未作答'],
                h: '00',//时
				m: '00',//分
				s: '00',//秒
				allTime: 0,
				timeId: null,
                popupSubimt: false,
                isSubmit: false,
                strOption: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
                wrongFk: [],
                activeWId: null,
                isScroll: false,
                timer: null,
                picturePreview: {
                    visible: false,
                    src: '',
                    closeOnClickModal: true
                },
                selectchick: [],
                isCode: false,
                codeData: null
            }
        },
        methods: {
            closeCodePop() {
                this.isCode=false
            },
            getConfigure() {
                this.$http.get("/api/v2/wrong_topic/getConfigure",{
                     headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    }
                })
                .then(res=>{
                    if(res.data.code===1){
                        this.codeData=res.data.data
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            getdata(data) {
                this.$http.get('/api/v2/testpaper/getTestpaperAnalysis',{
                    headers:{
                        'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                    },
                    params: data
                }).then((res) => {
                    if(res.data.code===1){
                        // console.log(res,559)
                        this.all_data=res.data.data
                        this.topic_data=res.data.data.topics;
                        this.addsize(this.topic_data)
                        if(this.$route.query.key!=undefined){
                            this.$nextTick(() => {
                                this.cardNav(this.$route.query.key)
                            }) 
                        }
                        // console.log(this.topic_data,996)
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                        var that=this;
                        if(res.data.msg=='暂无题目'){ //没有试题返回上一层页面
                            window.setTimeout(function(){
                                that.$router.go(-1);
                            },1000)
                        }
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },
            //图片放大
            previewPicture(e) {
                if(e.target.src){
                    this.picturePreview.src = e.target.src;
                    this.picturePreview.visible = true;
                }
            },
            addsize: function(e) { //题型分类
            	var that=this;
				e.forEach(function(item,index){
                	if(item.type===3){
                        item.answer=that.reAnswerData(item.answer.split(","))
                        item.userAnswer!==''?item.userAnswer=that.reAnswerData(item.userAnswer.split(",")):
                        item.userAnswer=[];
                    }
                })
            },
            reAnswerData: function(arr) {
				var aData=[];
				
					for(var i=0;i<arr.length;i++){
						aData[arr[i]]=arr[i]
					}
				
				return aData;
			},
            //收藏
            FavorSubject(e,i) {
                if(e.userFavor){
                    this.uncollect(e.id,i)
                }else{
                    this.collect(e.id,i)
                }
            },
            collect(id,i) {
                this.$http.post("/api/v2/question/collect",{
                    collection_testpaper_topic_id: id
                },
                {
                    headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                    }
                }).then(res=>{
                    if(res.data.code===1){
                        this.topic_data[i].userFavor=true
                        this.$message("收藏成功")
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            uncollect(id,i) {
                this.$http.post("/api/v2/question/unCollect",{
                    collection_testpaper_topic_id: id
                },
                {
                    headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                    }
                }).then(res=>{
                    if(res.data.code===1){
                        this.topic_data[i].userFavor=false
                        this.$message("取消收藏")
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            worngSubmit() {
                var type = [];
                for(var i=0;i<this.wrongFk.length;i++){
					if(this.wrongFk[i].checked){
						type.push(this.wrongFk[i].id)
					}
				}
                if(type.length == 0){
                    this.$message.error('请选择错误类型')
                    return false;
                }
                var data = {
					wrong_topic_cate_id: type.join(),
					topic_id: this.activeWId,
					testpaper_id: this.all_data.testpaper_id
				};
				this.textarea!=''? data.description=this.textarea:'';
                this.subtimApi(data)
            },
            subtimApi(data) {
                this.$http.post("/api/v2/wrong_topic/addWrongTopic",data,{
                    headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                        // 'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(res=>{
                    if(res.data.code===1){
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        })
                        this.dialogFormVisible = false
                        if(this.codeData&&this.codeData.status==1){
                            this.isCode=true
                        }
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
            },
            openPopfk(e) {
                // console.log(e,551)
                this.activeWId=e.topic_id
                this.textarea= ''
                this.wrongFk.forEach((e,i)=>{
                    e.checked=false
                })
                this.dialogFormVisible = true
            },
            FKselect(i) {
                this.wrongFk[i].checked=!this.wrongFk[i].checked
                var selectchick=[]
                for(var i=0;i<this.wrongFk.length;i++){
					if(this.wrongFk[i].checked){
						selectchick.push(this.wrongFk[i].id)
					}
				}
                this.selectchick=selectchick
            },
            scllotop() {
                let returnEle = document.querySelector(".paper_title_box");
                if(!!returnEle){
                    document.documentElement.scrollTop = returnEle.offsetTop
                }
            },
            getCategory() {
                this.$http.get("/api/v2//wrong_topic/getCategory").then(res=>{
                    if(res.data.code===1){
                        // console.log(res,888)
                        var w=res.data.data.lists
                        w.forEach((e,i)=>{
                            e.checked=false
                        })
                        this.wrongFk=w
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }
                })
            },
            toGrade() {
                this.$router.push({path: '/grade',query: {result_id:this.$route.query.result_id,score:this.$route.query.score}})
            },
            selectTitle(title) {
                this.testTitle = title;
                return 'aaaa'
            },
            getSingleData(index) {
                
                this.submitData[index[1]]=index[0]
                
            },
            getMultipleData(itemMultipleData) {
                this.submitData[itemMultipleData[1]]=itemMultipleData[0]
                
            },
            getTruefalseData(index) {
                this.submitData[index[1]]=index[0]
                
            },
            getSubjectiveData(subjctData) {
                this.submitData[subjctData[1]]=subjctData[0]  
            },
            cardNav(id) {
                // var allEle=document.querySelectorAll(".el-card__header");
                // let returnEle = document.querySelector("#option"+id);
                // !!returnEle && returnEle.scrollIntoView(true);


                // if(!!returnEle){
                //     document.documentElement.scrollTop = (returnEle.offsetTop - allEle[0].clientHeight)
                // }

                let returnEle = document.querySelector("#h"+id);
                if(!!returnEle){
                    document.documentElement.scrollTop = returnEle.offsetTop
                }
            },
            closeSbtPop() {
                this.isSubmit=false
            },
            openSbtPop() {
                this.isSubmit= true
            },
            SbtPop() {
                this.onSubmit()
                this.isSubmit=false
            },
            //自动提交
            closeSubmit() {
                this.onSubmit()
                this.popupSubimt=false
            },
            // 提交
            onSubmit() {
                var data = {},do_time,obj ={};
                this.topic_data.forEach((item,i)=>{
                    if (item.userAnswer !== ''&& (item.type==1||item.type==2||item.type==3)) {
                        data[item.id] = item.userAnswer
                    }
                })
                
                if(this.startSecond!='' && this.allTime>Number(this.startSecond)){
					do_time=Number(this.startSecond)
				}else{
					do_time=this.allTime
				}

                obj.testpaper_id=this.$route.query.id
                obj.do_time=do_time
                obj.data=data

                this.$http.post("/api/v2/testpaper/markTestpaper",obj,
                // {
                //     data:this.submitData,
                //     testpaper_id:this.$route.query.id
                //   },
                  {
                      headers:{
                          'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
                      }
                  })
                .then(res => {
                    
                    if(res.data.code===1){
                        // this.$router.push({name: 'analysis',params: {testpaper_id:res.data.data.testpaper_id,result_id:res.data.data.result_id}})
                        var data=res.data.data;
                        data.testpaper_name=this.testpaper_name;
                        this.$router.push({path: '/grade',query: data})
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                        
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
                .catch(errors => {
                    console.log(errors);
                }); 
                // console.log(this.$refs.headerChild.radio2) 
            },
            // 纠错反馈提交
            wrongSubmit() {
                this.dialogFormVisible = false;
                // console.log(this.form.checkboxGroup)
            },
            startCount(){
                // this.$refs.countdown.countTime();
            },
            mark(key) {
                flag=!flag;
                flag ? this.$refs.mark[key].className="activebj" : this.$refs.mark[key].className="bj";
                flag ? this.$refs.iMark[key].style.display="block" : this.$refs.iMark[key].style.display="none";
                
            },
            tiGanTop() {
                var tiGan=[];
                document.querySelectorAll(".card_tit").forEach(item => {
                    tiGan.push(item.offsetTop);
                })
                return tiGan;
            },
            handleScroll() {
                clearTimeout(this.timer)
                this.isScroll=true
                this.timer=setTimeout(()=>{
                    this.isScroll=false
                },2000)


                var tiGan=this.tiGanTops;
                var allEle=document.querySelectorAll(".el-card__header");
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                for(var i=0;i<tiGan.length;i++){
                    // 顺滚标题置顶
                    if(scrollTop>tiGan[i] && scrollTop<tiGan[i+1]){
                        allEle[i].style.position='fixed';
                        allEle[i].style.top=0;
                        allEle[i].style.zIndex=2;
                        allEle[i].style.background='#ffffff';
                        allEle[i].style.width=allEle[i].parentNode.offsetWidth+'px';
                    }else{
                        allEle[i].style='';
                    }

                    if(scrollTop>tiGan[tiGan.length-1]){
                        allEle[tiGan.length-1].style.position='fixed';
                        allEle[tiGan.length-1].style.top=0;
                        allEle[tiGan.length-1].style.zIndex=2;
                        allEle[tiGan.length-1].style.background='#ffffff';
                        allEle[tiGan.length-1].style.width=allEle[i].parentNode.offsetWidth+'px';
                    }else{
                        allEle[tiGan.length-1].style='';
                    }

                    // 回滚标题置顶
                    if(scrollTop<tiGan[tiGan.length-1]&&scrollTop>tiGan[tiGan.length-2]){
                        allEle[tiGan.length-2].style.position='fixed';
                        allEle[tiGan.length-2].style.top=0;
                        allEle[tiGan.length-2].style.zIndex=2;
                        allEle[tiGan.length-2].style.background='#ffffff';
                        allEle[tiGan.length-2].style.width=allEle[i].parentNode.offsetWidth+'px';
                    }else if(scrollTop<tiGan[i] && scrollTop>tiGan[i-1]){
                        allEle[i-1].style.position='fixed';
                        allEle[i-1].style.top=0;
                        allEle[i-1].style.zIndex=2;
                        allEle[i-1].style.background='#ffffff';
                        allEle[i-1].style.width=allEle[i].parentNode.offsetWidth+'px';
                        allEle[i].style='';
                    }else if(scrollTop<tiGan[0]){
                        allEle[0].style='';
                    }
                }
                
                
            },
            strcharacterDiscode
        },
        created() {
            // console.log(this.$route.query.key,770)
            this.$changeTitle(this.$route.query.testpaper_name+'--');
            this.testpaper_name=this.$route.query.testpaper_name;
    
            var obj={
                result_id: this.$route.query.result_id
            }
            
            this.getdata(obj)
            this.getCategory()
            this.getConfigure()
            store.commit('setNav',null);
        },
        mounted() {
            
            // handleScroll为页面滚动的监听回调
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);
            
        }
    }
</script>

<style scoped>
    body,#app{
        height: none;
    }
    .paper_title_box{
        width: 100%;
        height: 60px;
        background: #ffffff;
    }
    .paper_title{
        margin: 0 auto;
        width: 1200px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 18px;
        color: #333333;
    }
    .container_warp{
        width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        display: flex;
    }
    .paper_left{
        /* width: 270px;
        position: fixed;
        top: 80px; */
        width: 270px;
        margin-right: 20px;
    }
    /* .paper_left_flot{
        width: 270px;
        margin-right: 20px;
    } */
    .see_box{
        width: 270px;
        height: 50px;
        background: #00C590;
        border-radius: 25px;
        font-size: 18px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .card_box{
        margin-top: 20px;
        width: 270px;
        min-height: 540px; 
        background: #ffffff;
    }
    .card_title_box{
        background: #EDEDED;
        height: 50px;
        width: 100%;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
    }
    .mark_wrap{
        width: 100%;
        height: 60px;
        padding: 0 20px;
        box-sizing: border-box;
    }
    .mark_box{
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e7e7e7;
        box-sizing: border-box;
    }
    .mark_item{
        display: flex;
        align-items: center;
        font-size: 16px;
        /* width: 33.3%; */
    }
    .mark_item:nth-child(2){
        justify-content: center;
    }
    .mark_item:nth-child(3){
        justify-content: flex-end;
    }
    .mark_dot{
        width: 20px;
        height: 20px;
        background: #00C590;
        border-radius: 50%;
        margin-right: 10px;
    }
    .mark_dot_white{
        background: #ffffff;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        margin-right: 0;
        margin-right: 10px;
    }
    .mark_dot_red{
        background: #FF4C4C;
    }
    .card_opt{
        /* padding: 0 20px; */
        padding-bottom: 20px;
        font-size: 0;
    }
    .card_opt_title{
        font-size: 16px;
        color: #333333;
        margin-top: 20px;
        margin-left: 20px;
    }
    .card-btn-box{
        margin-top: 20px ;
        margin-left: 20px;
        display: inline-block;
    }
    .card_active{
        color: #ffffff;
        background: #00C590;
        border: none !important;
    }
    .cu-btn{
        width: 30px;
        height: 30px;
        border: 1px solid #CCCCCC;
        border-radius: 50%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #999999;
    }
    .paper_right{
        width: 910px;
    }
    .topic_main{
        background: #ffffff;
    }
    .tpc_top{
        margin-top: 20px;
    }
    .topic_title_box{
        width: 910px;
        box-sizing: border-box;
        min-height: 40px;
        display: flex;
        align-items: center;
        padding: 8px 0;
        /* line-height: 40px; */
        font-size: 18px;
        padding-left: 20px;
        background: #EDEDED;
    }
    .topic_wrap_pl{
        padding: 0 20px;
    }
    .material_box{
        width: 870px;
        height: 250px;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        box-sizing: border-box;
        overflow: auto;
    }
    .material_box::-webkit-scrollbar{
        width: 10px;
    }
    .material_box::-webkit-scrollbar-thumb{
        border-radius: 5px;
        background: #BBBBBB;
    }
    .material_box::-webkit-scrollbar-track{
        border-radius: 5px;
        background: #E7E7E7;
    }
    .topic_num_topline{
        border-top: 1px solid #E7E7E7;
    }
    .topic_num_btmline {
        border-bottom: 1px solid #E7E7E7;
    }
    .topic_num_box{
        /* height: 54px; */
        padding-top: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .tnb_left{
        display: flex;
        align-items: center;
    }
    .tn_dot{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #00C590;
        margin-right: 10px;
        position: relative;
    }
    .tn_dot:before{
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ffffff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .tnb_right{
        display: flex;
        align-items: center;
    }
    .tnb_right_w{
        margin-right: 20px;
        display: flex;
        align-items: center;
    }
    .tnb_right_s{
        display: flex;
        align-items: center;
    }
    .fk_img{
        width: 18px;
        height: 18px;
        margin-right: 6px;
    }
    .no_tpc{
        padding: 10px 0 30px;
        width: 100%;
        text-align: center;
    }
    .opt_group_box{
        /* padding-bottom: 10px; */
    }
    .radio_opt_wrap{
        margin-top: 20px;
        padding-left: 30px;
        position: relative;
    }
    .radio_opt_box{
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        border: 1px solid #CCCCCC;
        border-radius: 50%;
        box-sizing: border-box;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        color: #999999;
    }
    .opt_active{
        color: #ffffff;
        background: #00C590;
        border: 1px solid #00C590;
    }
    .el-card{
        border: none;
    }
    .el-main {
        color: #333;
    }
    /* .card_head{
        padding: 18px 20px;
        //border-bottom: 1px solid #EBEEF5;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    .card_conter{
        padding: 18px 0 18px 20px;
    } */
    /* .card_btm{
        margin-top: 10px;
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
    } */
    /* .t_title{
        padding-bottom: 10px;
    } */
    /* .title_analy{
        border-top: 1px solid #ddd;
        padding-top: 20px;
    } */
    .main_left{
        background: #fff; 
    }
    /* .material_box{
        border: 1px solid #ddd;
        padding: 5px 15px 5px 20px;
        margin-bottom: 40px;
        border-radius: 4px;
    } */
    /* .cardOption a{
        position: relative;
        display: inline-block;
        border-radius: 4px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #616161;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        border: 1px solid #e1e1e1;
    } */
    .active{
        background: #699975 !important;
        color: #fff !important;
    }
    .card_box{
        /* position: fixed; */
    }
    /* .right-sc{
        float: right;
        padding: 10px;
        margin-bottom: 10px
    }
    .right-sc div{
        float: left;
        font-size: 14px;
        color: #666;
        line-height: 30px;
        padding-left: 19px;
        margin-right: 20px;
        cursor: pointer;
    } */
    .checkbox{
        padding: 9px 10px 9px 10px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        line-height: normal;
        height: 40px;
        display: inline-block;
    }
    .activecheck{
        background: #699975;
        color: #fff;
        border-color: #699975 !important;
    }
    .bj{
        background: url(../assets/bj1.png) no-repeat left center;
    }
    .activebj{
        background: url(../assets/bj2.png) no-repeat left center;
    }
    .card_bj{
        /* display: none; */
        background: url(../assets/bj3.png) no-repeat 0px 0px;
        position: absolute;
        left: -1px;
        top: -1px;
        width: 25px;
        height: 25px;
    }
    .subit{
        margin: 0 auto;
        line-height: 40px;
        background: #47c88a;
        color: #fff;
        font-size: 16px;
        border-radius: 6px;
        text-align: center;
        max-width: 240px;
    }
    .padding-top{
        padding-top: 10px;
    }
    /* .main_left {
        margin-right: 10px;
    } */
    /* .margin_btm{
        margin-bottom: 10px;
    } */
    .material_box >>> img{
        max-width: 100%;
    }
    .txt_vh >>> img{
        max-width: 100%;
    }
    .j_anwer_content >>> img{
        max-width: 100%;
    }

    .popup >>> .el-dialog{
        width: 600px;
        height: 520px;
        overflow: auto;
        border-radius: 20px;
    }
    .popup >>> .el-dialog::-webkit-scrollbar{
        display: none;
    }
    .popup >>> .el-dialog__title{
        font-size: 22px;
        color: #333333;
        font-weight: 900;
    }
    .popup >>> .el-dialog__headerbtn .el-dialog__close{
        font-size: 28px;
    }
    .wrong_pop_title{
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 900;
    }
    .w_mt{
        margin-top: 30px;
    }
    .worng_nav_wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .textarea_wrap textarea{
        resize: none;
        border: none;
        width: 100%;
        height: 100%;
        outline:none;
        background: #ffffff;
    }
    .worng_nav{
        margin-right: 20px;
        margin-top: 20px;
    }
    .worng_nav_sub{
        border: 1px solid #DDDDDD;
        border-radius: 5px;
        padding: 12px 10px;
    }
    .popw_active{
        border: 1px solid #00C590;
        color: #00C590;
    }
    .textarea_wrap{
        margin-top: 20px;
        /* width: 540px; */
        width: 100%;
        height: 120px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
    }
    .wrong_pop_btn{
        margin: 30px auto 0;
        width: 300px;
        height: 50px;
        background: #00C590;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #ffffff;
    }

    .shade{
        width: 100%;
        height: 100%;
        background: rgba(122,122,122, .5);
        position: fixed;
        left: 0;
        top: 0;
    }
    .pop_submit{
        width: 400px;
        height: 280px;
        background: #FFFFFF;
        border-radius: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .code_pop_box{
        width: 420px;
        height: 420px;
    }
    .pop_submit_title{
        color: #333333;
        font-size: 20px;
        text-align: center;
        padding-top: 80px;
    }
    .pop_code_title{
        padding-top: 30px;
        text-align: center;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    .code_icon{
        width: 300px;
        height: 300px;
        margin: 30px auto 0;
    }
    .pop_submit_btn{
        margin-top: 60px;
        width: 200px;
        height: 50px;
        background: #00C590;
        font-size: 22px;
        color: #FFFFFF;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .pop_i_close{
        font-size: 28px;
        color: #999999;
        position: absolute;
        top: 20px;
        right: 20px;
    }
    .pop_code_close{
        font-size: 28px;
        color: #999999;
        position: absolute;
        top: 30px;
        right: 20px;
    }
    .pop_btm_btn{
        display: flex;
        justify-content: space-between;
        padding: 0 45px;
        margin-top: 60px;
        width: 100%;
        box-sizing: border-box;
    }
    .p_left_btn,
    .p_right_btn{
        width: 140px;
        height: 50px;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
    }
    .p_left_btn{
        background: #00C590;
        color: #fff;
    }
    .p_right_btn{
        color: #00C590;
        border: 1px solid #00C590;
        box-sizing: border-box;
    }
    .only_r{
		color: #00C590;
		border:1px solid #00C590;
	}
    .r_active{
        background: #00C590;
        color: #ffffff;
        border: none;
    }
    .w_active{
        background: #FF4C4C;
        color: #ffffff;
        border: none;
    }
    .r_txt{
        color: #00C590;
    }
    .w_txt{
        color: #FF4C4C;
    }
    .n_txt{
        color: #59AAFF;
    }
    .anwer_box{
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
    .anwer_box_left,.anwer_box_right{
        font-size: 16px;
        font-weight: bold;
    }
    .anwer_box_left{
        display: flex;
        align-items: center;
    }
    .statu_img{
        width: 21px; 
        height: 21px;
        margin-right: 9px;
    }
    .anwer_box_right{
        margin-left: 30px;
        color: #333333;
    }
    .self_anwer_txt{
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #333333;
        margin-top: 10px;
    }
    .j_anwer_box{
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-top: 20px;
    }
    .j_anwer_content{
        font-weight: 400;
    }
    .j_anwer_content_pt{
        margin-top: 20px;
    }
    .analy_btm_padd{
        padding-bottom: 30px;
    }
    .scllotop_img{
        width: 31px;
        height: 31px;
        position: fixed;
        bottom: 100px;
        right: 320px;
    }
    .ogrey{
        opacity: .3;
    }
    .self_score{
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
    }
    .footer_block{
        width: 100%;
        height: 30px;
    }
</style>
<style>
    #app{
        min-width: 960px;
    }
</style>



// WEBPACK FOOTER //
// src/page/Analysis.vue